import React from 'react';
import { translate } from '../../Services/translation';

const CheckoutCustomerInfoLabel = ({
  stepComplete,
  showSignIn,
  isB2b,
  loginUrl,
}: {
  stepComplete: boolean;
  showSignIn: boolean;
  isB2b: boolean;
  loginUrl?: string;
}) => {
  return (
    <div className="flex flex-1 flex-col">
      <h3 className="text-h3">
        {translate(
          isB2b ? 'checkout.delivery-address' : 'checkout.customer-info'
        )}
      </h3>
      {showSignIn && loginUrl && !stepComplete && (
        <div className="text-md text-gray-900">
          {translate('checkout-private-customer.have-an-account')}{' '}
          <a className="underline" href={loginUrl}>
            {translate('global.log-in')}
          </a>
        </div>
      )}
    </div>
  );
};

export default CheckoutCustomerInfoLabel;
